var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreadsLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08341 8.30912C12.364 5.03013 16.7303 7.36314 16.3046 12.2348C15.8788 17.1064 12.863 16.9488 12.3292 16.9488C7.23245 16.9488 7.67806 11.2097 13.0409 11.2097C22.6591 11.2097 22.0782 22.3725 12.1108 22.3725C8.20059 22.3725 3.12402 20.386 3.12402 11.6673C3.12402 0.504397 17.0549 -2.73285 20.8768 7.82022",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreadsLine);
export default __webpack_public_path__ + "static/media/threads_line.12ae9cf63f918c59fec110fbc94a9717.svg";
export { ForwardRef as ReactComponent };